import React, { forwardRef } from 'react';

const Button = forwardRef(({
    variant = 'icon',
    icon,
    text,
    /** `text` variant only: `start` (default) = icon then label; `end` = label then icon. */
    iconPosition = 'start',
    children,
    onClick,
    style,
    className = '',
    type = 'button',
    'aria-label': ariaLabel,
    ...rest
}, ref) => {
    if (variant === 'icon' && !ariaLabel && children == null) {
        throw new Error('Button: icon variant requires an aria-label.');
    }

    const baseStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '6px',
        border: 'none',
        cursor: 'pointer',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
    };

    const variantStyle = variant === 'text' ? {
        padding: '6px 16px',
        gap: '8px',
    } : {
        padding: `6px 16px`,
    };

    const iconEl = icon ? (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                lineHeight: 0,
            }}
        >
            {icon}
        </span>
    ) : null;

    const textEl = (
        <span className="text-body-sm">
            {text}
        </span>
    );

    const content = children ?? (
        variant === 'text' ? (
            iconPosition === 'end' ? (
                <>
                    {textEl}
                    {iconEl}
                </>
            ) : (
                <>
                    {iconEl}
                    {textEl}
                </>
            )
        ) : (
            icon
        )
    );

    return (
        <button
            ref={ref}
            type={type}
            className={`app-button app-button--${variant} ${className}`.trim()}
            aria-label={ariaLabel}
            style={{ ...baseStyle, ...variantStyle, ...style }}
            onClick={onClick}
            {...rest}
        >
            {content}
        </button>
    );
});

export default Button;